import { useState, useEffect } from 'react';

/**
 * Inline style that draws an image as a CSS mask: the image gives the shape, the element's
 * background color gives the fill. Width comes from the image's aspect ratio at the given
 * height (capped at maxWidth), since a masked element has no intrinsic size of its own.
 * Null until the image has loaded, or when src is empty.
 */
const useLogoMask = (src, height, maxWidth = Infinity) => {
  const [style, setStyle] = useState(null);

  useEffect(() => {
    if (!src) { setStyle(null); return undefined; }
    let live = true;
    const img = new Image();
    img.onload = () => {
      if (!live) return;
      // An SVG without width/height reports 0; fall back to a 4:1 logo shape.
      const ratio = img.naturalWidth && img.naturalHeight ? img.naturalWidth / img.naturalHeight : 4;
      const mask = `url("${src}")`;
      setStyle({ width: `${Math.round(Math.min(maxWidth, height * ratio))}px`, maskImage: mask, WebkitMaskImage: mask });
    };
    img.onerror = () => { if (live) setStyle(null); };
    img.src = src;
    return () => { live = false; };
  }, [src, height, maxWidth]);

  return style;
};

export default useLogoMask;
